import { useParams, useLocation } from "react-router-dom";
import JuniorCourse from "./JuniorCourse";
import SeniorCourse from "./SeniorCourse";

function CourseContentRouterOperations() {
  const { courseName } = useParams();
  const location = useLocation();

  const props = location.state;

  if (courseName.includes("JUNIOR")) {
    return <JuniorCourse {...props} />;
  }

  if (courseName.includes("SENIOR")) {
    return <SeniorCourse {...props} />;
  }

  return <div>Course Not Found</div>;
}

export default CourseContentRouterOperations;